import AuditTrail from "../audit.trail";

export const LinkLog = (WrappedComponent) => (props) => {
  const { onClick, event, eventParams, ...otherProps } = props;

  const onLog = (event, action, eventParams) => {
      if (event && action) {
          AuditTrail.sendLog(event, Object.assign({tag: 'link', event: action, label: props.label? props.label : '', value: props.value}, eventParams));
      }
  }

  return (
    <WrappedComponent
        {...otherProps}
        onClick={(context) => {
            onLog(event, 'onClick', eventParams);
            if (props.onClick) {
                props.onClick(context);
            }
        }}
    />
  );
};
